import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '@libs/core/auth';
import { CompanyInterceptor } from '@libs/core/auth-fma';
import { AlertService } from './alert.service';
import { ApiErrorsInterceptor, NOTIFICATION_SERVICE } from './api-error.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: AuthInterceptor },
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: CompanyInterceptor },
  { provide: HTTP_INTERCEPTORS, multi: true, useClass: ApiErrorsInterceptor },
  { provide: NOTIFICATION_SERVICE, useClass: AlertService },
];
